<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import { isPhoneE164OrEmpty, isNumber } from 'shared/helpers/Validators';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiUrl: '',
      apiUrlToken: '',
      apiKeyConceptoMovil: '',
      apiToken: '',
      wabaId: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required },
    apiUrl: { required },
    apiUrlToken: { required },
    apiKeyConceptoMovil: { required },
    apiToken: { required },
  },
  methods: {
    async createChannelCustom() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      try {
        const payload = {
          name: this.inboxName?.trim(),
          channel: {
            type: 'whatsapp',
            phone_number: this.phoneNumber,
            provider: 'concepto_movil_cloud',
            provider_config: {
              api_url: this.apiUrl,
              api_url_token: this.apiUrlToken,
              api_key_concepto_movil: this.apiKeyConceptoMovil,
              api_token: this.apiToken,
              waba_id: this.wabaId,
            },
          },
        };

        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannelCustom',
          payload
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        console.error('[ConceptoMovil] createChannelCustom error:', error);
        if (error?.response) {
          console.error('[ConceptoMovil] response:', error.response);
        }
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannelCustom()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiUrl.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_URL.LABEL') }}
        </span>
        <input
          v-model="apiUrl"
          type="url"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_URL.PLACEHOLDER')"
          @blur="v$.apiUrl.$touch"
        />
        <span v-if="v$.apiUrl.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_URL.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiUrlToken.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_URL_TOKEN.LABEL') }}
        </span>
        <input
          v-model="apiUrlToken"
          type="url"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_URL_TOKEN.PLACEHOLDER')"
          @blur="v$.apiUrlToken.$touch"
        />
        <span v-if="v$.apiUrlToken.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_URL_TOKEN.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiKeyConceptoMovil.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY_CONCEPTO_MOVIL.LABEL') }}
        </span>
        <input
          v-model="apiKeyConceptoMovil"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY_CONCEPTO_MOVIL.PLACEHOLDER')"
          @blur="v$.apiKeyConceptoMovil.$touch"
        />
        <span v-if="v$.apiKeyConceptoMovil.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY_CONCEPTO_MOVIL.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiToken.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.LABEL') }}
        </span>
        <input
          v-model="apiToken"
          type="password"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.PLACEHOLDER')"
          @blur="v$.apiToken.$touch"
        />
        <span v-if="v$.apiToken.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        <span>WABA ID</span>
        <input
          v-model="wabaId"
          type="text"
          placeholder="WABA ID"
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
